import { v3company } from '@/store/core/v3/company';
export var v3 = {
    namespaced: true,
    modules: {
        v3company: v3company,
    },
};
